import AdvertisingMediaImportForm from './AdvertisingMediaImportForm';

export default AdvertisingMediaImportForm;
